<template>
  <div class="flex relative">
    <div class="flex justify-center w-full" v-if="hasSessions">
        <PlannerColumnDesktop class="md:w-1/6 flex-col" v-if="!isDaily || (isDaily && !isGroupAndPastDay)" v-for="column in plannerInfo.planner.columns" :key="column.label" :column="column" :is-daily="isDaily" />
      </div>

      <div v-else>
        <PlannerFallback :isDaily="isDaily" />
      </div>
  </div>
</template>

<script setup>
import { defineProps, inject, computed } from 'vue';

import PlannerColumnDesktop from './PlannerColumnDesktop.ce.vue';
import PlannerFallback from './PlannerFallback.ce.vue';

defineProps({
  isDaily: {
    type: Boolean,
    default: false
  },
  isGroupAndPastDay: {
    type: Boolean,
    default: false
  }
});

const plannerInfo = inject('plannerInfo');
const hasSessions = inject('plannerHaveSessions');

</script>
